import el from 'element-ui/lib/locale/lang/ko';

/* eslint-disable */
export default {
  app: {
    name: 'Okubuy',
    login: '登入',
    logout: '登出',
    register: '註冊',
    default: '默認',
    create_account: '建立賬號',
    delete: '刪除',
    edit: '編輯',
    tips: '提示',
    confirm: '確定',
    cancel: '取消',
    save: '保存',
    view_more: '查看更多',
    view: '查看',
    share: '分享',
    submit: '提交',
    no_limit: '不限',
    file_only_accept_jpg_png: '上傳文件只能是 jpg、png格式',
    file_size_only: '上傳圖片大小不能超過{size}',
    search: '搜索',
    reset: '重置',
    select_all: '全選',
    inputMoreThanWords: '輸入不能少於{0}個字符',
    please_login: '請先登錄賬號',
    submit_err: '提交失敗',
    delete_err: '刪除失敗',
  },
  topbar: {
    faq: '常見問題',
    guide: '新手指南',
    exchange_rate: '參考匯率',
  },
  nav: {
    home: '首頁',
    proxy_buy: '代購',
    straight: '直購',
    shop: '商店',
    forwarding: '轉送',
    proxy_request: '請求代購',
    product_promotion: '商品推介',
    new_product: '最新商品',
    off_price_product: '特價商品',
    recommend_product: '推薦商品',
    hot_sales_product: '熱銷商品',
    free_postage_product: '包郵商品',
    all_product: '所有商品',
  },
  shop_names: {
    rakuten: 'Rakuten',
    yahoo_jp: 'YAHOO!JAPAN',
    amazon_jp: 'Amazon JP',
  },
  login: {
    page_title: '登入或建立帳號',
    registered: '已註冊？',
    login_tips: '如果您已有帳號，請登入',
    remember_me: '記住我',
    forgot_password: '忘記密碼？',
    placeholder: {
      account: '請輸入登錄賬號或郵箱',
      password: '請輸入登錄密碼',
    },
    rules_message: {
      account_required: '請輸入登錄賬號或電郵',
      password_required: '請輸入登錄密碼',
    },
    un_regisered: '還未註冊?',
    register_tips: '註冊免費而快捷!',
    registered_infos: [
      '能夠快速結帳',
      '能夠登錄多個收貨地址',
      '能夠查看追蹤訂單狀態',
    ],
    login_fail: '登錄失敗',
  },
  register: {
    page_title: '創建賬戶',
    register_tips: '輸入下列信息来創建您的賬戶',
    accepted: '同意并繼續',
    reject: '拒絕',
    read_and_accepted: '我已閱讀并同意',
    labels: {
      email: '電子郵箱',
      phone: '電話號碼',
      password: '密碼',
      password_confirmation: '確認密碼',
      referral_code: '介紹人會員號碼',
    },
    placeholder: {
      email: '請輸入電郵地址',
      phone: '請輸入您的電話號碼',
      password: '設置您的密碼，長度必須介乎 6 至 20 個字符之間',
      password_confirmation: '請再次確認您的密碼',
      referral_code: '填寫您的介紹人會員號碼，選填項',
    },
    rules_message: {
      email_type: '請輸入正確的電郵',
      email_required: '請填寫電郵地址',
      phone_required: '請填寫您的電話號碼',
      password_required: '請輸入登錄密碼',
      password_length: '長度必須介乎{min}至{max}個字符之間',
      password_confirmation_required: '請再次確認密碼',
      password_not_comfirmed: '兩次輸入的密碼不一致',
    },
  },
  activation: {
    thank_you_registered: '感謝您註冊{appname}',
    active_your_account: '請激活您的帳號',
    send_mail_tips: '我們已經發送郵件到您的電子郵箱:{email}，請按照郵件指示激活您的帳號',
    resend_link: '如果您沒有收到郵件，點擊這裡重新發送',
    activing: '正在激活您的賬戶...',
    activation_successed: '您的賬戶已激活，祝購物愉快！！',
    bind_successed: '綁定成功，祝購物愉快！！',
    activation_failed: '激活失敗',
  },
  user: {
    user_center: '會員中心',
    my_account: '我的賬戶',
    my_orders: '我的訂單',
    product_view_history: '我的足跡',
    history_err: '獲取我的足跡失敗',
    information: '個人信息',
    wish_list: '我的收藏',
    shipping_address: '收貨地址',
    proxy_list: '代購請求',
    registration_in: '註冊于',
    last_login_time: '上次登錄時間',
    coupon: '優惠券',
    balance: '餘額',
    logout: '登出',
    order_detail: '訂單詳情',
    orders_err: '獲取訂單失敗',
    go_to_login: '去登入',
    added_to_wishlist: '已加入收藏夾',
    removed_wishlist: '已移出收藏夾',
    success: '修改成功',
    upload_img_err: '上传头像图片大小不能超过 2MB!',
  },
  user_info: {
    personal: '修改資料',
    avatar_image: '上傳頭像',
    login_name: '登錄名',
    update_password: '修改密碼',
    old_password: '原始密码',
    new_password: '新密码',
    confirm_password: '確認密码',
    keep: '保存',
    actual_name: '真實姓名',
    can_only_be_changed_once: '登錄名只能修改一次',
    gender: '性別',
    male: '男',
    female: '女',
    secrecy: '未知',
    birthday: '生日',
    choose_birthday: '選擇日期',
    phone_number: '電話號碼',
  },
  order: {
    id: '訂單號',
    type: '订单类型',
    quantity: '數量',
    amount: '金額',
    status: '訂單狀態',
    order_date: '下單日期',
    subtotal: '小計',
    name: '商品名稱',
    price: '價格',
    size: '尺碼',
    color: '顏色',
    shipping: '運費',
    tax: '稅',
    total: '總計',
    total_tax: '稅',
    shipping_fee: '運費',
    local_shipping_fee: '本地運費',
    overseas_shipping_fee: '海外運費',
    handling_fee: '手續費',
    contains_shipping_fee: '含運費',
    order_detail: '訂單詳情',
    created_at: '下單時間',
    filter_all: '所有訂單',
    filter_unpaid: '待付款',
    filter_shipping: '已發貨',
    filter_uncomment: '待評價',
    filter_closed: '已關閉',
    filter_completed: '完成',
    filter_wait_for_pickup: '待自提',
    filter_last_3_months: '最近3個月訂單',
    filter_last_6_months: '最近半年訂單',
    filter_input_placeholder: '搜索訂單號或者商品名',
    payment_method: '付款方式',
    payment_status: '付款狀態',
    payment_timeout_tips: '請在以下時間前付款，超時訂單自動關閉',
    wait_for_ship: '等待倉庫發貨',
    step1: '提交訂單',
    step2: '付款成功',
    step3: '商品發貨',
    step4: '確認收貨',
    step5: '評價',
    step6: '待付款',
    shipping_info: '收貨信息',
    shipping_method: '配送方式',
    payment_info: '付款信息',
    products: '訂單商品',
    total_product: '商品總價',
    total_price: '總價錢',
  },
  wish_list: {
    product_name: '商品名稱',
    clear_wish_list: '清空收藏列表',
    add_to_wish_list_err: '添加收藏夾失敗',
    remote_wish_list_err: '移除收藏夾失敗',
    confirm_clear_list: '確定清空列表嗎',
  },
  product: {
    id: '商品ID',
    product: '商品',
    name: '商品名稱',
    product_categories: '商品分類',
    detail: '詳細',
    price: '售價',
    old_price: '原價',
    unit_price: '單價',
    specification: '規格',
    brand: '品牌',
    unit_tax: '稅',
    original_price: '原價',
    total: '總價',
    quantity: '數量',
    subtotal: '小計',
    product_details: '商品詳情',
    upc: '商品編號',
    inventory: '庫存',
    availability: '可用性',
    description: '寶貝詳情',
    comment: '評論',
    comment_has_number: '評論({0})',
    product_name: '商品名稱',
    weight: '重量',
    length: '長度',
    width: '寬度',
    height: '高度',
    specification_and_packaging: '規格與包裝',
    advisories: '咨詢',
    advisories_has_number: '咨詢({0})',
    comment_time: '評論時間',
    recovery_time: '回復時間',
    let_us_help_you_to_answer_your_doubts: '提出你的疑惑，讓我們來幫你解答',
    to_ask_questions: '提問',
    question: '問',
    answer: '答',
    no_answer: '暫無回答',
    advisory_err: '提問失敗',
    input_more_than4_words: '請輸入4個字以上',
    product_list: '商品列表',
    all_categories: '所有分類',
    load_more: '加載更多商品',
    load_more_error: '加載商品失敗，請稍後再試',
    tax_included: '含稅',
  },
  product_list: {
    shop_categories: '商品分類',
    price_range: '價格範圍',
    filter: '過濾',
    filter_by_brand: '按品牌過濾',
    list_page_total: '共{0}個商品',
    sort_by: '排序',
    sort_by_index: '綜合',
    sort_by_new: '上架時間',
    search_keyword: '搜索关键字',
    brand: '品牌',
  },
  shipping_address: {
    add_address: '添加新地址',
    consignee: '收貨人',
    mobile: '移動電話',
    phone: '固話',
    email: '電郵',
    district: '地區',
    zip_code: '郵編',
    address: '地址',
    address_detail: '詳細地址',
    company: '公司',
    additional_information: '額外信息',
    set_default: '設為默認',
    confirm_delete: '確定要刪除該收貨地址嗎？',
    deleted: '收貨地址已刪除',
    label: '地址參考名稱',
    label_placeholder: '建議填寫常用名稱',
    my_home: '家庭',
    parents_home: '父母家',
    express_box: '快遞柜',
    consignee_placeholder: '填寫收貨人姓名',
    zip_code_placeholder: '填寫郵政編碼',
    email_placeholder: '接收訂單物流信息郵件',
    company_placeholder: '填寫公司名稱',
    mobile_placeholder: '填寫移動電話號碼',
    area_code: '區號',
    phone_placeholder: '區號-固話號碼-分機號',
    select_district: '請選擇收貨地址地區',
    address_placeholder: '建議您如實填寫詳細收貨地址，例如街道名稱，門牌號碼，樓層和房間號等信息',
    additional_information_placeholder: '',
    confirm_close_dialog: '收貨地址還沒有保存，確定關閉？',
    edit_address: '編輯地址',
    required_field_no_compltet: '帶*號為必填項，請填寫完整',
    address_has_been_save: '地址已保存',
    tracking_number: '跟蹤號碼',
    zipcode: '邮编',
  },
  area: {
    china_mainland: '中國大陸',
    hongkong: '香港',
    macao: '澳門',
    taiwan: '台灣',
  },
  footer: {
    contacts: '咨詢',
    contact_us: '聯絡我們',
    phone: '電話',
    monday_friday: '週一至五',
    customer_service: '客戶服務',
    faq: '常見問題',
    delivery: '送貨安排',
    payment_method: '付款方法',
    information: '資訊',
    news: '最新消息',
    terms_and_conditions: '條款及條件',
    privacy_policy: '私隱政策',
    about_us: '聯絡我們',
    my_account: '我的賬戶',
    contact_us_me: '與我們聯繫',
    subscription: '訂閱',
    show_map: '顯示地圖地址',
    subscribe: '訂閱我們的通訊，以接收早期的折扣優惠，最新消息，銷售和宣傳信息。',
  },
  home: {
    featured_products: 'Featured Products',
    sale_products: '特價商品',
    top_sellers: '熱銷商品',
    new_arrivals: '最新商品',
    recommend_products: '推薦商品',
    popular_brands: '熱門品牌',
    shipping: '免費送貨',
    shipping_detailed: '所有超過100美元的訂單免運費',
    money_back: '退款保證',
    money_back_detailed: '我們會在30天内退貨',
    customer_support: '全天候客戶支持',
    customer_support_detailed: '友好的全天候客戶支持',
    secure_online_payment: '安全在線支付',
    secure_online_payment_detailed: '我們擁有SSL/安全證書',
  },
  cart: {
    add_to_cart: '添加到購物車',
    cart: '購物車',
    view_cart: '查看購物車',
    checkout: '結算',
    no_login_tips: '您还沒有登入！登入后購物車的商品將保存到您的賬號中',
    continue_shipping: '繼續購物',
    operation: '操作',
    remove: '刪除',
    add_to_wishlist: '收藏商品',
    product_has_been_removed: '商品已從購物車中移除',
    product_has_benn_removed_to_wishlist: '商品已經移到收藏夾',
    product_move_to_wishlist_and_remove_cart: '商品移到收藏夾并移除購物車',
    update_to_cart_err: '更新購物車失敗',
    empty_cart_tips: '您的購物車沒有商品',
    total_product: '商品總價',
    total_tax: '稅總計',
    add_to_cart_err: '加入購物車失敗',
    update_cart_err: '更改購物車失敗',
    it_is_cheaper: '價錢比之前便宜了',
    it_is_expensive: '價錢比之前貴了',
    remove_err: '移除失敗',
  },
  redemption_center: {
    name: '自提點',
    district: '地區',
    address: '地址',
    phone: '電話',
    business_hours: '營業時間',
  },
  order_pay: {
    pay_id: 'PAY ID',
    amount: '金額',
    pay_time: '付款時間',
  },
  checkout: {
    product: '商品',
    unit_price: '單價',
    unit_tax: '稅',
    quantity: '數量',
    price: '價錢',
    additional_information: '額外信息',
    shipping_methods: '配送方式',
    district_only_hk: '暫時只支持配送香港地區',
    self_pick_up: '自提點取件',
    courier: '快遞',
    self_point_address: '自提點地址',
    shipping_address: '收貨地址',
    add_shipping_address: '新增收貨地址',
    payment_method: '付款方式',
    audit_order: '審核訂單',
    order_created: '已創建訂單',
    prev: '上一步',
    next: '下一步',
    back_to_cart: '回到購物車',
    your_cart_is_empty: '您的購物車沒有商品',
    go_to_shopping: '去購物',
    submit_orders: '提交訂單',
    picker: '取件人',
    phone: '手機號碼',
    placeholders: {
      name: '取件人姓名，用於取件時核對',
      phone: '取件密碼將會發送到該手機號碼，請確定該號碼可收取短信',
    },
    rules: {
      picker_required: '請填寫取件人姓名',
      phone_required: '請填寫取件人的電話，取件密碼將會發送到該手機號碼',
    },
    checkout_fail: '結賬失敗',
    get_self_point_address_err: '獲取自提點失敗',
    get_shipping_address_err: '獲取收貨地址失敗',
  },
  proxy_request: {
    code: '編號',
    contact_phone: '聯繫電話',
    product_name: '商品名',
    product_url: '商品URL',
    image: '圖片',
    price: '參考價格',
    quantity: '數量',
    size: '型號/尺寸',
    color: '顏色',
    remark: '備註',
    created_at: '日期',
    status: '狀態',
    click_upload: '點擊上傳',
    placeholders: {
      contact_phone: '請留下您的聯繫電話，以便客服確認您的代購商品',
      product_name: '輸入您所需要代購的商品名',
      product_url: '輸入您需要代購的商品的URL',
      price: '以HKD為貨幣單位的商品參考價格，實際交易價格以訂單為準',
      size: '如果商品頁面中含有多款型號/尺寸，請輸入你所需要的型號/尺寸',
      color: '如果商品頁面中含有多款顏色，請輸入你所需要的顏色',
    },
    rules: {
      contact_phone_required: '請留下您的聯繫電話，以便客服確認您的代購商品',
      product_name_required: '請填寫商品名稱',
      product_url_required: '請填寫購物網站的URL',
      product_url: '請填寫正確的URL地址，以http://或https://開頭',
      price_required: '請填寫商品價格',
      quantity_required: '請填寫代購商品數量',
      shipping_method_required: '請選擇配送方式',
      redemption_center_id_required: '請選擇自取點',
      address_id_required: '請選擇收貨地址',
      payment_method_required: '請先用paypal付款',
    },
    please_add_shipping_address: '請先添加收貨地址',
    not_found: '沒有該代購請求',
    updated: '您的代購請求已修改',
    created: '已提交您的代購請求',
    canceled: '您的代購請求已取消',
    reject: '您的代購請求被拒絕',
    reject_reason: '拒絕原因',
    cancel: '取消',
    cancel_tips: '您確定要取消這個代購請求嗎？',
  },
  rakuten: {
    product_detail: '樂天商品',
    product_info: '商品信息',
    tax_include: '含稅',
    view_item_from_rakuten: '閱覽樂天頁面',
    shop_name: '店铺名稱',
    item_code: '商品代码',
    category: '分類',
    tag: '標籤',
    review_count: '評價數',
    review_count_text: '{0}個商品評論',
    review_average: '綜合評價',
    shipping_tips: '若商品屬於違禁品或禁止販售至海外的商品均有可能無法通關。我們將取消此類商品的訂單。敬請見諒。',
  },
  yahoo: {
    product_detail: '雅虎商品',
    view_item_from_yahoo: '閱覽雅虎頁面',
    shop_name: '店铺名稱',
    item_code: '商店代碼',
    review_count: '評價數',
    review_count_text: '{0}個商品評論',
    review_average: '綜合評價',
    category: '分類',
    product_info: '商品信息',
    view_review: '查看評價',
    shipping_tips: '若商品屬於違禁品或禁止販售至海外的商品均有可能無法通關。我們將取消此類商品的訂單。敬請見諒。',
  },
  amazon: {
    product_detail: '亞馬遜商品',
  },
  faq: {
    answer_your_questions: '此FAQ是否有解答到您的疑问？',
    thankyou_for_your_feedback: '提交成功！非常感谢您的反馈，我们会继续努力做到更好！',
    most_popular_questions: '最热门问题',
    account_registration: '會員註冊',
    making_purchase: '購買商品',
    package: '包裹入倉與發送',
    other_questions: '其它',
    ask_us: '還沒有找到答案？問我們。',
    we_respond_within_2days: '我們通常會在2個工作日内回復。最熱門的問題將出現在此頁面上。',
    subject: '主題',
    your_name: '名稱',
    cellphone: '電話號碼',
    email: '郵箱',
    category: '分類',
    question: '問題',
    placeholder: {
      name: '填寫您的名稱',
      email: '填寫您的郵箱地址',
      category: '請選擇問題類型',
      question: '請填寫您的問題',
      subject: '請填寫你的主題',
      cellphone: '請填寫您的電話號碼',
    },
    rules: {
      name: '名稱不能為空',
      email: '郵箱地址不能為空',
      correct_email: '請填寫正確的郵箱地址',
      category: '請選擇問題類型',
      question: '問題不能為空',
      question_len: '問題至少輸入3個字符',
      subject: '主題不能為空',
    },
  },
  information: {
    information: '資訊',
    news: '最新消息',
    terms_and_conditions: '條款及條件',
    privacy_policy: '私隱政策',
    about_us: '聯絡我們',
  },
  facebook_pannel: {
    homepage: 'facebook主頁',
    line1: '讃好我們的facebook賬號',
    line2: '您可以在這裡了解到Okubuy的最新消息',
  },
  transportation: {
    parcel_list: '郵包列表',
    warehouses: '倉庫地址',
    parcel_information:'請輸入網站發貨的貨倉地址、快遞公司、追蹤號碼、貨件資料去確認貨件',
    parcel_screen: '郵包篩選',
    goods_name:'貨品名',
    Valuation_fee:'保價費用(HKD)',
    parcel_describe:'郵包內含物描述',
    parcel_status: '郵包狀態',
    track_num :'追蹤號碼',
    ware: '貨倉',
    weight_pounds: '重量(磅)',
    courier_tracknum: '快遞公司 / 追蹤號碼',
    new_status: '最新狀態',
    product_details: '貨品詳情 / 貨值',
    push_parcel: '主動推送郵包',
    cancel_record: '取消記錄',
    completion_information:'補全信息',
    addgoods: '添加商品',
    send_out: '送出',
    placeholder:{
      choose: '请选择',
      warehouse_courier:'選擇倉庫地址及快遞公司',
      status:'请选择狀態',
      warehouses: '请选择倉庫',
      tracking_num: '请輸入追蹤號碼' ,
    },
   label: {
      warehouse_courier: '倉庫地址及快遞公司',
      tracking_num: '追蹤號碼',
      unit: '單位'
   },
  },
  ...el,
}
